import service from '@/utils/request'

export function indexInfo(data) {
  return service({
    url: '/myicecadmin/prod/index/info',
    method: 'get',
    data
  })
}

export function indexArticles(params) {
  return service({
    url: '/myicecadmin/prod/index/articles',
    method: 'get',
    params
  })
}

export function indexStaff(params) {
  return service({
    url: '/myicecadmin/prod/index/staff',
    method: 'get',
    params
  })
}

export function indexSprider(params) {
  return service({
    url: '/myicecadmin/prod/index/sprider',
    method: 'get',
    params
  })
}
